module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "card-wrap",
    style: ({
      border: '1px solid' + _vm.bgcolor
    })
  }, [(_vm.showTitle) ? _c('div', {
    staticClass: "card-head",
    style: ({
      background: _vm.bgcolor,
      height: _vm.headHeight + 'px',
      lineHeight: _vm.headHeight + 'px',
      color: _vm.headColor
    })
  }, [_vm._t("title")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("content")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66db3a29","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/card.vue
// module id = 1173
// module chunks = 1